const handleRawResponse = async response => response;
const handleResponse = async response => response.data;
const handleError = error => {
    console.error(`api.call.error:${error}`);
    throw error;
};

export {
    handleRawResponse,
    handleResponse,
    handleError
};
